/**
 * Trade API service.
 *
 * All calls go through {@link apiClient} with paths that omit the `/api`
 * prefix (the base URL already includes `/api` via runtime config), matching
 * `protective-put-service.ts` and the other frontend services.
 *
 * Validates: Requirements 7.1
 */

import type { OptionOutcomeInput, TradePosition } from '@covered-calls/shared';
import { apiClient } from './api-client';

/**
 * Record the end-of-life outcome of an active covered call
 * (expired worthless / assigned called away).
 */
export async function recordOptionOutcome(
  positionId: string,
  input: OptionOutcomeInput
): Promise<TradePosition> {
  return apiClient.post<TradePosition>(
    `/trades/${positionId}/option-outcome`,
    input
  );
}
